import React from "react";
import {
  Container,
  Title,
  Header,
  HeaderTitle,
  HeaderIconLeft,
  HeaderIconRight,
  TableContainer,
  TableHeader,
  TableBody,
} from "./Component/TableComponent/Table";
import InputSearch from "./Component/Search/Search";
import PickColumn from "./Component/PickColumn/PickColumn";
import Action from "./Component/Action/Action";
import AddGroup from "./Component/AddGroup/AddGroup";
import CreatedOn from "./Component/CreatedOn/CreatedOn";
import Filter from "./Component/Filter/Filter";

import { buyers } from "./Component/Utils/Utils";

export default function OSPTrash() {
  const RowHeader = [
    "ID",
    "Status",
    "Company Name",
    "Email",
    "Assignes",
    "Phone Number",
    "Location",
    "Tags",
    "Action"
  ];
  // const { rows, isLoading, error } = Usefetch_Get(
  //   "http://localhost:4000/Table"
  // );
  const path = "/admin-dashboard/view-osp/";

  return (
    <div>
      <Container>
        <Title>Trash</Title>
        <Header>
          <HeaderTitle>
            <HeaderIconLeft>
              <InputSearch />
              <PickColumn />
            </HeaderIconLeft>
            <HeaderIconRight>
              <Action />
              <Filter />
              <AddGroup />
              <CreatedOn />
            </HeaderIconRight>
          </HeaderTitle>
          <TableContainer>
            <TableHeader children={RowHeader} />
            <TableBody
              rows={buyers}
              // isLoading={isLoading}
              // error={error}
              path={path}
            />
          </TableContainer>
        </Header>
      </Container>
    </div>
  );
}
